/**
 * Web stub for Lottie React Native
 * Provides a compatible component for web platform
 */
import React, { forwardRef } from 'react';

interface LottieViewProps {
  source?: any;
  style?: any;
  resizeMode?: string;
  autoPlay?: boolean;
  loop?: boolean;
  [key: string]: any;
}

const LottieView = forwardRef<any, LottieViewProps>((props, ref) => {
  React.useImperativeHandle(ref, () => ({
    play: () => {},
    reset: () => {},
    pause: () => {},
    resume: () => {},
    stop: () => {},
  }), []);

  return React.createElement(
    'div',
    {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f0f0',
        borderRadius: '50%',
        ...props.style,
      },
    },
    React.createElement('span', { style: { color: '#999', fontSize: '12px' } }, '♥')
  );
});

LottieView.displayName = 'LottieView';

export default LottieView;
